import {
  SETTING_CHANGE_TABLE_OPTIONS,
  SETTING_CHANGE_VALUE,
  SETTING_CHANGE_VALUES,
  SETTING_CLOSE_ACTION_MODAL,
  SETTING_PLATFORM_USERS,
  SETTING_USER,
  SETTING_TECHNICIAN,
  SETTING_DISABLE_USER,
  SETTING_DISABLE_TECHNICIAN,
  SETTING_ERROR,
} from '@shared/store/constants/mutationTypes';

import apiClient from '@shared/lib/general/apiClient';
import errorCatch from '@shared/lib/errorCatch';
import createErrorMessage from '@shared/lib/errorCatch/createErrorMessage';
import { PARTNER_DETAIL_CHANGE_VALUE } from '@/store/constants/mutationTypes';

const actions = {
  changeSettingValue({ commit }, payload) {
    const { field, value } = payload;
    commit({
      type: SETTING_CHANGE_VALUE,
      field,
      value,
    });
  },
  changeSettingValues({ commit }, payload) {
    commit({
      type: SETTING_CHANGE_VALUES,
      changes: payload,
    });
  },
  changeTableOptions({ commit }, payload) {
    const { options, field, value } = payload;

    commit({
      type: SETTING_CHANGE_TABLE_OPTIONS,
      options,
      field,
      value,
    });
  },
  async getUserCorpSetting({ commit, rootState }) {
    const {
      admin: {
        current: { corporationId },
      },
    } = rootState;
    const { data: partner } = await apiClient({
      method: 'GET',
      url: `/corporations/id/${corporationId}`,
    });
    const { data } = await apiClient({
      method: 'GET',
      url: '/partner/settings',
    });
    const partnerSettings = {};
    Object.keys(data).forEach((key) => {
      let value = data[key];
      if (value === 'true') {
        value = true;
      } else if (value === 'false') {
        value = false;
      }
      if (value[0] === '[' || value[0] === '{') {
        value = JSON.parse(data[key]);
      }
      partnerSettings[key] = value;
    });
    commit({
      type: SETTING_CHANGE_VALUES,
      changes: [
        {
          field: 'loadingCurrentCorporation',
          value: false,
        },
        {
          field: 'currentCorporation',
          value: partner,
        },
        {
          field: 'partnerSettings',
          value: partnerSettings,
        },
      ],
    });
  },
  async parseTechnicianUpload({ commit, dispatch }, payload) {
    const { text } = payload;
    const textSplit = text.split('\n');
    const errorObj = {};
    const uploadErrorArr = [];
    let fIdx = -1;
    let lIdx = -1;
    let phoneIdx = -1;
    let emailIdx = -1;
    const headers = textSplit.splice(0, 1)[0].split(',');
    headers.forEach((h, idx) => {
      const lowerCase = h.toLowerCase();
      if (lowerCase.includes('firstname')) {
        fIdx = idx;
      } else if (lowerCase.includes('lastname')) {
        lIdx = idx;
      } else if (lowerCase.includes('phone')) {
        phoneIdx = idx;
      } else if (lowerCase.includes('email')) {
        emailIdx = idx;
      }
    });
    if (fIdx === -1) {
      uploadErrorArr.push('First Name column is missing!');
    }
    if (lIdx === -1) {
      uploadErrorArr.push('Last Name column is missing!');
    }
    if (phoneIdx === -1) {
      uploadErrorArr.push('Phone column is missing!');
    }
    if (emailIdx === -1) {
      uploadErrorArr.push('Email column is missing!');
    }
    commit({
      type: SETTING_CHANGE_VALUES,
      changes: [
        {
          field: 'errorObj',
          value: errorObj,
        },
        {
          field: 'parsingTechnician',
          value: false,
        },
      ],
    });
    if (uploadErrorArr.length === 0) {
      const allTechs = [];
      textSplit.forEach((row, idx) => {
        const info = row.split(',');
        if (info.length > 1) {
          const cleanedInfo = info.map((v) => {
            let value = v;
            if (v.indexOf('\r') !== -1) {
              value = v.substring(0, v.indexOf('\r'));
            }
            return value.trim();
          });
          const firstName = cleanedInfo[fIdx];
          const lastName = cleanedInfo[lIdx];
          const email = emailIdx !== -1 ? cleanedInfo[emailIdx] : null;
          const phone = phoneIdx !== -1 ? cleanedInfo[phoneIdx] : null;
          if (firstName) {
            if (!firstName) {
              uploadErrorArr.push(`First name is missing on line ${idx + 2}`);
            }
            if (!lastName) {
              uploadErrorArr.push(`Last name is missing on line ${idx + 2}`);
            }
            if (!phone) {
              uploadErrorArr.push(`Phone is missing on line ${idx + 2}`);
            }
            if (!email) {
              uploadErrorArr.push(`Email is not valid on line ${idx + 2}`);
            }
            allTechs.push({
              firstName,
              lastName,
              email,
              phone,
            });
          }
        }
      });

      if (uploadErrorArr.length > 0) {
        errorObj.uploadErrorArr = uploadErrorArr;
        commit({
          type: SETTING_CHANGE_VALUES,
          changes: [
            {
              field: 'errorObj',
              value: errorObj,
            },
            {
              field: 'parsingTechnician',
              value: false,
            },
          ],
        });
      } else if (allTechs.length > 0) {
        dispatch('createBulkTechnician', allTechs);
        commit('SET_SNACKBAR', {
          show: true,
          color: 'success',
          message: 'Upload Success',
        });
      }
    } else {
      errorObj.uploadErrorArr = uploadErrorArr;
      commit({
        type: SETTING_CHANGE_VALUES,
        changes: [
          {
            field: 'errorObj',
            value: errorObj,
          },
          {
            field: 'parsingTechnician',
            value: false,
          },
        ],
      });
    }
  },
  async getServiceCategories({ commit }) {
    const { data: categoryList } = await apiClient({
      method: 'GET',
      url: '/services/category/list',
    });

    commit({
      type: PARTNER_DETAIL_CHANGE_VALUE,
      field: 'serviceCategoryList',
      value: categoryList,
    });
    commit({
      type: SETTING_CHANGE_VALUE,
      field: 'serviceCategoryList',
      value: categoryList,
    });
  },
  async setPartnerSetting({ rootState }, payload) {
    const {
      admin: {
        current: { corporationId: corpId },
      },
    } = rootState;
    const request = payload.map((p) => ({
      ...p,
      corpId: p.corpId ?? corpId,
    }));
    await apiClient({
      method: 'POST',
      url: '/partner/settings/set',
      data: request,
    });
  },
  async getTaxExemptCategory({ dispatch }) {
    try {
      const { data } = await apiClient({
        method: 'GET',
        url: '/partner/settings/taxexempt/category',
      });
      const taxExemptCategory = [];
      Object.keys(data).forEach((key) => {
        taxExemptCategory.push({
          code: key,
          reason: data[key],
        });
      });

      dispatch('changeSettingValues', [
        {
          field: 'taxExemptCategory',
          value: taxExemptCategory,
        },
      ]);
    } catch (err) {
      console.error(err);
    }
  },
  async setTaxExempt(s, formData) {
    try {
      await apiClient({
        method: 'POST',
        url: '/partner/settings/taxexempt',
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    } catch (err) {
      console.error(err);
    }
  },
  async setContract({ commit }, formData) {
    try {
      await apiClient({
        method: 'POST',
        url: '/partner/settings/contract',
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    } catch (err) {
      console.error(err);
      commit('SET_SNACKBAR', {
        show: true,
        color: 'error',
        message: err,
      });
    }
  },
  async updateCorporation({ dispatch, state }, payload) {
    const {
      currentCorporation: { id },
      currentCorporation,
    } = state;
    await apiClient({
      method: 'PUT',
      url: `/corporations/update/${id}`,
      data: {
        ...payload,
        id,
      },
    });
    const updatedCorporation = {
      ...currentCorporation,
      ...payload,
    };
    dispatch('changeSettingValues', [
      {
        field: 'currentCorporation',
        value: updatedCorporation,
      },
    ]);
  },
  async updateCorporationSetting({ dispatch, state }, payload) {
    try {
      const { partnerSettings } = state;

      const newSettings = {
        ...partnerSettings,
        ...payload,
      };

      const updateSettings = Object.keys(newSettings).map((key) => {
        let value = newSettings[key];
        if (typeof value === 'object') {
          value = JSON.stringify(value);
        } else if (value) {
          value = value.toString();
        }
        return {
          settingName: key,
          settingValue: value,
        };
      });
      await apiClient({
        method: 'POST',
        url: '/partner/settings/set',
        data: updateSettings,
      });
      dispatch('changeSettingValues', [
        {
          field: 'partnerSettings',
          value: newSettings,
        },
      ]);
      dispatch('changeAdminValues', [
        {
          field: 'partnerSettings',
          value: newSettings,
        },
      ]);
    } catch (err) {
      console.error(err);
    }
  },
  async updateCorporationLogo({ state, dispatch }, payload) {
    const { corpId } = payload;
    const { partnerSettings } = state;
    payload.append('corpId', corpId);
    const { data } = await apiClient({
      method: 'POST',
      url: '/partner/settings/logo/upload/new',
      data: payload,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    const newSettings = {
      ...partnerSettings,
    };
    if (data.LOGO_URL) {
      newSettings.LOGO_URL = data.LOGO_URL;
    }
    if (data.CUSTOM_APP_ICON) {
      newSettings.CUSTOM_APP_ICON = data.CUSTOM_APP_ICON;
    }
    dispatch('changeSettingValues', [
      {
        field: 'partnerSettings',
        value: newSettings,
      },
    ]);
    dispatch('changeAdminValues', [
      {
        field: 'partnerSettings',
        value: newSettings,
      },
    ]);
  },
  async updateCorporationAddress({ state, dispatch }, payload) {
    const {
      currentCorporation: { id },
      currentCorporation,
    } = state;
    let update = false;
    if (payload.id) {
      await apiClient({
        method: 'PUT',
        url: `/addresses/corporations/${id}/${payload.id}`,
        data: payload,
      });
      update = true;
    } else {
      payload.corpId = id;
      const { data } = await apiClient({
        method: 'POST',
        url: `/addresses/corporations/${id}`,
        data: payload,
      });
      payload.id = data.id;
      payload.status = 'Active';
    }
    const newCurrentCorporation = {
      ...currentCorporation,
    };
    if (payload.type.toLowerCase() === 'shipping' || payload.type.toLowerCase() === 'billing') {
      const type = `${payload.type.toLowerCase()}Address`;

      if (update) {
        if (payload.status.toLowerCase() === 'deleted') {
          const updatedList = newCurrentCorporation[type].filter((a) => a.id !== payload.id);
          newCurrentCorporation[type] = [...updatedList];
        } else {
          const updatedList = newCurrentCorporation[type].map((address) => {
            if (address.id === payload.id) {
              return payload;
            }
            return address;
          });
          newCurrentCorporation[type] = [...updatedList];
        }
      } else {
        newCurrentCorporation[type] = [...newCurrentCorporation[type], payload];
      }
    }
    dispatch('changeSettingValues', [
      {
        field: 'currentCorporation',
        value: newCurrentCorporation,
      },
    ]);
  },
  async saveTenantId({ dispatch }, payload) {
    const { tenantId, corpId } = payload;
    await apiClient({
      method: 'POST',
      url: `/servicetitan/tenant-id/${tenantId}/corp/${corpId}`,
    });
    dispatch('getUserCorpSetting');
  },
  async saveClientSecret({ dispatch }, payload) {
    await apiClient({
      method: 'POST',
      url: '/servicetitan/client-secret',
      data: payload,
    });
    dispatch('getUserCorpSetting');
  },
  async disconnectStIntegration({ rootState, dispatch }) {
    const {
      admin: {
        current: { corporationId: corpId },
      },
    } = rootState;
    await apiClient({
      method: 'PUT',
      url: `/servicetitan/disconnect/${corpId}`,
    });
    dispatch('getUserCorpSetting');
  },
  async createUser({ commit, rootState, state }, admin) {
    const { actionModalView } = state;

    const {
      admin: {
        current: { corporationId, id: adminId },
      },
    } = rootState;

    try {
      if (admin.email) {
        const { data } = await apiClient({
          method: 'GET',
          url: `/admins/email/${admin.email}`,
        });
        if (data.email === admin.email) {
          throw new Error('Email already exists');
        }
      }
    } catch (err) {
      console.error(err);
    }

    try {
      const newObj = {
        ...admin,
      };
      newObj.createdBy = adminId;
      if (!newObj.corporationId) {
        newObj.corporationId = corporationId;
      }
      let result;
      if (actionModalView === 'new-user') {
        const { data } = await apiClient({
          method: 'POST',
          url: '/admins/new',
          data: newObj,
        });
        result = data;
      } else {
        newObj.password = null;
        const { data } = await apiClient({
          method: 'PUT',
          url: `/admins/update/${newObj.id}`,
          data: newObj,
        });
        result = data;
      }

      commit({
        type: SETTING_USER,
        result,
      });
      commit({
        type: SETTING_CLOSE_ACTION_MODAL,
      });
      return true;
    } catch (err) {
      const apiError = createErrorMessage(err);
      if (Object.keys(apiError).length) {
        commit({
          type: SETTING_ERROR,
          errorObj: apiError,
        });
      }
      throw err;
    }
  },
  async createTechnician({ commit, rootState, state }, technician) {
    const { actionModalView } = state;
    const {
      admin: {
        current: { id: adminId, corporationId },
      },
    } = rootState;

    const errorObj = errorCatch('newTechnician', technician);

    try {
      if (technician.email) {
        const { data } = await apiClient({
          method: 'GET',
          url: `/technicians/email/${technician.email}`,
        });
        if (data.email === technician.email) {
          errorObj.techEmailErr = 'User already exists. Please use different email address.';
        }
      }
    } catch (err) {
      console.error(err);
    }

    commit({
      type: SETTING_ERROR,
      errorObj,
    });

    if (Object.keys(errorObj).length === 0) {
      try {
        const newNT = { ...technician, adminId };

        if (!newNT.corporationId) {
          newNT.corporationId = corporationId;
        }

        // name, corpName is not part of VO
        // delete name, corpName
        delete newNT.name;
        delete newNT.corpName;

        let responseData;
        if (actionModalView === 'new-technician') {
          const { data } = await apiClient({
            method: 'POST',
            url: '/technicians/new',
            data: newNT,
          });
          responseData = data;
        } else {
          const { data } = await apiClient({
            method: 'PUT',
            url: `/technicians/update/${newNT.id}`,
            data: newNT,
          });
          responseData = data;
        }

        commit({
          type: SETTING_TECHNICIAN,
          result: responseData,
        });
        commit({
          type: SETTING_CLOSE_ACTION_MODAL,
        });
        return true;
      } catch (err) {
        const apiError = createErrorMessage(err);

        if (Object.keys(apiError).length) {
          commit({
            type: SETTING_ERROR,
            errorObj: apiError,
          });
        }
        throw err;
      }
    }
    return false;
  },
  async createBulkTechnician({ commit, rootState }, technicians) {
    const {
      admin: {
        current: { id: adminId, corporationId },
      },
    } = rootState;

    const bulkUpload = [];

    try {
      technicians.forEach(async (technician) => {
        if (technician.email) {
          const { data } = await apiClient({
            method: 'GET',
            url: `/technicians/email/${technician.email}`,
          });
          if (data.email !== technician.email) {
            const newNT = { ...technician, adminId };

            if (!newNT.corporationId) {
              newNT.corporationId = corporationId;
            }

            bulkUpload.push(
              await apiClient({
                method: 'POST',
                url: '/technicians/new',
                data: newNT,
              }),
            );
          }
        }
      });
      await Promise.all(bulkUpload);
    } catch (err) {
      console.error(err);
      commit('SET_SNACKBAR', {
        show: true,
        color: 'error',
        message: err,
      });
    }
  },
  async deactivateTechnician({ commit }, payload) {
    const { id } = payload;

    commit({
      type: SETTING_CHANGE_VALUE,
      field: 'editing',
      value: true,
    });

    await apiClient({
      method: 'PUT',
      url: `/technicians/disable/${id}`,
    });

    commit({
      type: SETTING_DISABLE_TECHNICIAN,
      id,
    });

    commit({
      type: SETTING_CLOSE_ACTION_MODAL,
    });
  },
  async deactivateUser({ commit }, payload) {
    const { id } = payload;

    commit({
      type: SETTING_CHANGE_VALUE,
      field: 'editing',
      value: true,
    });

    await apiClient({
      method: 'PUT',
      url: `/admins/disable/${id}`,
    });

    commit({
      type: SETTING_DISABLE_USER,
      id,
    });

    commit({
      type: SETTING_CLOSE_ACTION_MODAL,
    });
  },
  async getAllPlatformUsers({ commit }, payload) {
    const queryId = payload === 1 ? payload : -payload;

    const { data } = await apiClient({
      method: 'GET',
      url: `/admins/all/${queryId}`,
    });
    commit({
      type: SETTING_PLATFORM_USERS,
      platformUsers: data,
    });
  },
  async getSmacPlatformUsers({ commit }) {
    const { data } = await apiClient({
      method: 'GET',
      url: '/admins/all/1',
    });
    commit({
      type: SETTING_CHANGE_VALUE,
      field: 'platformSmacUsers',
      value: data,
    });
  },
  async getAdminPSMList({ commit }) {
    const { data } = await apiClient({
      method: 'GET',
      url: '/admins/all/psm',
    });
    commit({
      type: SETTING_CHANGE_VALUE,
      field: 'psmList',
      value: data,
    });
  },
  async changeUserPassword({ state }, payload) {
    const { currentUser } = state;
    const { password } = payload;

    await apiClient({
      method: 'PUT',
      url: '/auth/admin/change-password',
      data: {
        id: currentUser.id,
        password,
      },
    });
  },
  async getAlertList({ commit }) {
    const { data: alertTypes } = await apiClient({
      method: 'GET',
      url: '/testdata/alert/types/list',
    });
    commit({
      type: SETTING_CHANGE_VALUE,
      field: 'alertTypes',
      value: alertTypes,
    });
  },
  async getImageResponse(s, payload) {
    const { url, logo } = payload;
    let path = '/devices/ac/image/response';
    if (logo) {
      path = '/devices/ac/image/response?logo=true';
    }
    const { data } = await apiClient({
      url: path,
      method: 'PUT',
      data: {
        url,
      },
    });
    return data;
  },
  async getDocResponse(s, payload) {
    const { url } = payload;
    try {
      const { data } = await apiClient({
        url: '/devices/ac/image/doc/response',
        method: 'PUT',
        data: {
          url,
        },
      });
      return data;
    } catch (e) {
      console.error(e);
      return '';
    }
  },
  async getBillingPaymentMethod({ dispatch, rootState }, corpId) {
    const {
      admin: {
        current: { corporationId },
      },
    } = rootState;
    dispatch('changeSettingValues', [
      {
        field: 'loadingPaymentMethod',
        value: true,
      },
    ]);
    const { data } = await apiClient({
      method: 'GET',
      url: `/chargebee/corporation/${corpId ?? corporationId}/payment-method/all`,
    });
    const { data: customer } = await apiClient({
      method: 'GET',
      url: `/chargebee/corp/${corpId ?? corporationId}/customer`,
    });
    const paymentMethods = data.map((p) => {
      const newP = { ...p };
      if (p.id === customer?.primary_payment_source_id) {
        newP.primary = true;
      }
      return newP;
    });
    dispatch('changeSettingValues', [
      {
        field: 'selectedPaymentMethod',
        value: paymentMethods || [],
      },
      {
        field: 'chargebeeCustomer',
        value: customer,
      },
      {
        field: 'loadingPaymentMethod',
        value: false,
      },
    ]);
  },
  async getInvoicePdf(_, payload) {
    const { data } = await apiClient({
      method: 'GET',
      url: `/chargebee/invoice/${payload}/pdf`,
    });
    return data;
  },
  async getRecentInvoicesMethod({ dispatch, rootState }, payload) {
    const {
      admin: {
        current: { corporationId },
      },
    } = rootState;
    dispatch('changeSettingValues', [
      {
        field: 'loadingInvoices',
        value: true,
      },
    ]);
    const { data } = await apiClient({
      method: 'GET',
      url: `/chargebee/corp/${payload ?? corporationId}/billing/recent`,
    });
    dispatch('changeSettingValues', [
      {
        field: 'recentInvoices',
        value: data,
      },
      {
        field: 'loadingInvoices',
        value: false,
      },
    ]);
  },
  async getInvoiceAddendum(_, payload) {
    const { data } = await apiClient({
      method: 'GET',
      url: `/vouchers/invoiced/${payload}`,
    });
    return data;
  },
  async getSubscriptions({ dispatch, rootState }, payload) {
    const {
      admin: {
        current: { corporationId },
      },
    } = rootState;
    dispatch('changeSettingValues', [
      {
        field: 'loadingSubscriptions',
        value: true,
      },
    ]);
    const { data } = await apiClient({
      method: 'GET',
      url: `/chargebee/corp/${payload ?? corporationId}/subscriptions`,
    });
    dispatch('changeSettingValues', [
      {
        field: 'subscriptions',
        value: data,
      },
      {
        field: 'loadingSubscriptions',
        value: false,
      },
    ]);
  },
  async updateDefaultPaymentMethod({ dispatch, state }, payload) {
    const {
      currentCorporation: { id },
    } = state;
    await apiClient({
      method: 'PUT',
      url: `/chargebee/corp/${id}/payment-method/${payload}/default`,
    });
    dispatch('getBillingPaymentMethod');
  },
  async updateInvoiceNote({ dispatch }, payload) {
    const { corpId, note } = payload;
    const { data } = await apiClient({
      method: 'PUT',
      url: `/chargebee/corp/${corpId}/update-note?note=${note}`,
    });
    dispatch('changeSettingValues', [
      {
        field: 'chargebeeCustomer',
        value: data,
      },
    ]);
  },
  async createChargebeeContact({ dispatch, state }, payload) {
    const {
      currentCorporation: { id },
    } = state;
    const { corpId, invoiceEmail } = payload;
    const { data } = await apiClient({
      method: 'POST',
      url: `/chargebee/corp/${corpId ?? id}/contact/add/${invoiceEmail}`,
    });
    dispatch('changeSettingValues', [
      {
        field: 'chargebeeCustomer',
        value: data,
      },
    ]);
  },
  async deleteChargebeeContact({ dispatch, state }, corpId) {
    const {
      currentCorporation: { id },
      chargebeeContactId,
    } = state;
    const { data } = await apiClient({
      method: 'DELETE',
      url: `/chargebee/corp/${corpId ?? id}/contact/delete/${chargebeeContactId}`,
    });
    dispatch('changeSettingValues', [
      {
        field: 'chargebeeCustomer',
        value: data,
      },
    ]);
  },
  async removeBillingPaymentMethod({ dispatch, state }) {
    const {
      currentCorporation: { id },
      paymentMethodId,
      paymentMethod,
    } = state;
    const corporation = {
      id,
      paymentMethodId,
      paymentOption: paymentMethod,
    };
    await apiClient({
      method: 'DELETE',
      url: `/chargebee/customer/${id}/payment-method/delete`,
      data: corporation,
    });
    await dispatch('getBillingPaymentMethod');
  },
  async addBillingPaymentMethod({ dispatch, state }) {
    const {
      currentCorporation: { id, firstName, lastName, email, phone, billingAddress },
      cardToken,
      source,
      paymentMethodId,
      paymentMethod,
    } = state;
    const corporation = {
      id,
      firstName,
      lastName,
      email,
      phone,
      cardToken,
      source,
      paymentMethodId,
      paymentOption: paymentMethod,
      billingAddress,
    };
    await apiClient({
      method: 'POST',
      url: '/chargebee/corporation/payment-method/default',
      data: corporation,
    });
    await dispatch('getBillingPaymentMethod');
    dispatch('changeSettingValues', [
      {
        field: 'showActionModal',
        value: false,
      },
    ]);
  },
  async createIdentityProvider({ state }, payload) {
    const {
      currentCorporation: { id },
    } = state;
    await apiClient({
      method: 'POST',
      url: `/auth/sso/provider/save/${id}`,
      data: payload,
    });
  },
  async getIdentityProvider({ state }, payload) {
    const {
      currentCorporation: { id },
    } = state;
    const { data } = await apiClient({
      method: 'GET',
      url: `/auth/sso/provider/${payload ?? id}`,
    });
    return data;
  },
  closeSettingActionModal({ commit }) {
    commit({
      type: SETTING_CLOSE_ACTION_MODAL,
    });
  },
  async getAgreements({ commit, rootState }) {
    const {
      admin: {
        current: { corporationId },
      },
    } = rootState;
    const { data } = await apiClient({
      method: 'POST',
      url: `/partner/agreement/query/${corporationId}`,
      data: {},
    });
    commit({
      type: SETTING_CHANGE_VALUES,
      changes: [
        {
          field: 'agreements',
          value: data,
        },
      ],
    });
  },
};

export default actions;
